<style lang="less">

.app-menu{
  .h-menu{
    font-size: 14px;
    .h-menu-li-selected{
      .h-menu-show:after {
        width: 4px;
      }
    }
    > li a {
      .h-menu-show {
        font-size: 15px;
        .h-menu-show-icon {
          font-size: 20px;
        }
      }
    }
    > li >.h-menu-show {
      font-size: 15px;
      .h-menu-show-icon {
        font-size: 20px;
      }
      .h-menu-show-desc{
        transition: opacity 0.1s cubic-bezier(0.645, 0.045, 0.355, 1), width 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
      }
    }
  }
  .h-menu.h-menu-size-collapse > .h-menu-li > .h-menu-show {
    padding-left: 24px;
    .h-menu-show-icon {
      font-size: 20px;
    }
  }
  .h-menu.h-menu-size-collapse > .h-menu-li > a > .h-menu-show > .h-menu-show-desc {
    opacity: 0;
    display: inline-block;
    width: 0;
    text-overflow: clip;
  }
  .h-menu.h-menu-size-collapse > .h-menu-li > a > .h-menu-show {
    padding-left: 24px;
  }
  .h-menu.h-menu-white {
    color: rgb(49, 58, 70);
  }

}

//custom
#app .h-layout-sider {
  box-shadow: 0 -1px 7px rgba(41, 16, 0, 0.2);
}
.h-menu-dark {
  color: #f3f3f3;
}
.h-menu-dark .h-menu-show {
  transition: 0.3s;
}
.h-menu-dark .h-menu-show:hover {
  background: #ef8e4f;
}
.h-menu-dark .h-menu-li-selected {
  background: #ef8e4f;
  border-right: 4px solid #ffffff;
  color: #ffffff;
}

.h-menu-disabled {
  background-color: #f5f5f5;
  border-color: #d3d3d3;
  color: #999999;
}
.h-menu-dark  .h-menu-disabled:hover .h-menu-show{
  background-color: inherit;
  border-color: inherit;
  color: inherit;
  cursor: no-drop;
}

.slide-leave-active,
  .slide-enter-active {
    transition: 0.1s;
  }
  .slide-enter {
    transform: translate(100%, 0);
  }
  .slide-leave-to {
    transform: translate(-100%, 0);
  }

</style>
<template>
  <div class="app-menu">
    <appLogo :theme="theme" class="app-bg"></appLogo>
    <transition name="slide" mode="out-in">
      <Menu :accordion="true" v-if="!isEditorMode" :datas="menus" :inlineCollapsed="siderCollapsed"  @click="trigger" ref='menu' :className="`h-menu-${theme}`"></Menu>
      <MenuModoEditor v-if="isEditorMode"/>
    </transition>
    <div class="app-menu-mask" @click="hideMenu"></div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import appLogo from './app-logo';
import MenuModoEditor from './MenuModoEditor';

export default {
  props: {
    theme: String
  },
  data() {
    return {
      menus: [],
      telasMobile: []
    };
  },
  watch: {
    $route() {
      this.menuSelect();
    },
    siderCollapsed() {
      this.checkRoutesMobile();
    }
    // menus: {
    //   immediate: true,
    //   handler(value) {
    //     this.$nextTick(() => {
    //       const indices = this.menus.map((menu, index) => menu.permissao === false ? index : false).filter(menu => !!menu);
    //       this.$refs.menu.$el.querySelectorAll('.h-menu-li').forEach((item, index) => {
    //         if (indices.includes(index)) {
    //           item.classList.add('h-menu-disabled');
    //         }
    //       });
    //     });
    //   }
    // }
  },
  async mounted() {
    this.checkRoutesMobile();
    this.menuSelect();
  },
  computed: {
    ...mapState([
      'siderCollapsed'
    ]),
    isEditorMode() {
      return this.$store.state.dashboard.isEditorMode;
    }
  },
  methods: {
    menuSelect() {
      if (this.$route.name) {
        this.$refs.menu.select(this.$route.name);
      }
    },
    trigger(data) {
      if (data.value.permissao === false) return;
      if (data.children.length > 0) return;
      if (event.ctrlKey) return;

      this.$router.push({ name: data.key });
      if (window.innerWidth <= 900) {
        this.hideMenu();
      }
    },
    hideMenu() {
      this.$store.commit('updateSiderCollapse', true);
    },
    checkRoutesMobile() {
      const menu = require('../../js/config/menu-config').default;
      const naoExibirNoMobile = ['arquivos', 'vendedores', 'revendedores', 'metas', 'Gerenciar'];
      this.telasMobile = menu.filter(m => !naoExibirNoMobile.includes(m.key));
      this.is_mobile = this.checkIfIsMobile();
      this.menus = this.is_mobile ? this.telasMobile : menu;
    }
  },
  components: {
    appLogo,
    MenuModoEditor
  }
};
</script>
